import { createSelector } from 'reselect';
import { normalizePolices } from './utils';

/**
 * @return {channelModel[]}
 */
export const rootChannelsSelector = createSelector(
  (state) => state.admin.channels,
  (channels) => channels
);

export const adminIsLoadedSelector = createSelector(
  (state) => state.admin.loading,
  (_) => !_
);

/**
 * @return {policyModel[]}
 */
export const policiesSelector = createSelector(
  (state) => state.admin.policies,
  (policies) => policies
);

/**
 * @return {policyModel[]}
 */
export const normalizedPoliciesSelector = createSelector(
  (state) => normalizePolices(state.admin.policies),
  (policies) => policies
);
